import { render, staticRenderFns } from "./classeFinance.vue?vue&type=template&id=22541d96&"
import script from "./classeFinance.vue?vue&type=script&lang=js&"
export * from "./classeFinance.vue?vue&type=script&lang=js&"
import style0 from "./classeFinance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports